import { ButtonHTMLAttributes, CSSProperties, ReactNode } from 'react';
import * as S from './styles';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string | ReactNode;
  containerStyle?: CSSProperties;
  outlined?: boolean;
}

const Button = ({ text, outlined, containerStyle, ...rest }: Props) => {
  return (
    <S.ButtonStyled
      type="button"
      outlined={outlined}
      style={containerStyle}
      {...rest}
    >
      {text}
    </S.ButtonStyled>
  );
};

Button.defaultProps = {
  containerStyle: {},
  outlined: false,
};

export default Button;
